module.exports = __webpack_public_path__ + "static/media/user-music.a4173689.svg";